import React from 'react';

import Box, { BoxProps } from '@mui/material/Box';

export type ContainerProps = {
  children: React.ReactNode;
  maxWidth?: string;
  rootSx?: BoxProps['sx'];
  containerSx?: BoxProps['sx'];
};

const Container = ({ children, maxWidth = '1136px', rootSx = {}, containerSx = {} }: ContainerProps) => {
  return (
    <Box sx={{ width: '100%', ...rootSx }}>
      <Box sx={{ maxWidth, margin: 'auto', ...containerSx }}>{children}</Box>
    </Box>
  );
};

export default Container;
